import * as React from "react";
import axios from "axios";
import { useWatch } from "react-hook-form";
import { DropdownInput } from "../../runQuote/components/DropdownInput";
import { stateOptions } from "data";

export function InsuredState({ control, producers, setValue }) {
  const [allowedStates, setAllowedStates] = React.useState([]);
  const [carriersData, setCarriersData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const insuredState = useWatch({ control, name: "step1.insuredState" });

  React.useEffect(() => {
    async function fetchAllowedStates() {
      try {
        const response = await axios.get("/api/quote/allowedStates", {
          params: { type: "individual" },
        });
        const apiData = response.data.data || [];

        setCarriersData(apiData);

        const producerStates = producers?.data?.states || [];

        const producerStateCodes = stateOptions
          .filter((opt) => producerStates.includes(opt.value))
          .map((opt) => opt.label);

        const normalizeStateCode = (stateValue) => {
          const match = stateOptions.find(
            (opt) => opt.label === stateValue || opt.value === stateValue
          );
          return match?.label || stateValue;
        };

        const allAllowedStates = new Set(
          apiData
            .flatMap((carrier) => carrier.AllowedStates)
            .map((stateValue) => normalizeStateCode(stateValue))
        );

        const filteredAllowedStates = Array.from(allAllowedStates).filter((code) =>
          producerStateCodes.includes(code)
        );

        const finalAllowedStateOptions = stateOptions.filter((opt) =>
          filteredAllowedStates.includes(opt.label)
        );

        setAllowedStates(finalAllowedStateOptions);
      } catch (error) {
        console.error("Failed to fetch allowed states", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllowedStates();
  }, [producers]);

  React.useEffect(() => {
    if (!insuredState || !carriersData.length) {
      setValue("step1.allowedCarriers", [], { shouldValidate: false });
      return;
    }

    const selectedState = stateOptions.find((opt) => opt.value === insuredState);
    const selectedStateCode = selectedState?.label;
    const selectedStateName = selectedState?.value;

    const allowedCarriers = carriersData
      .filter((carrier) =>
        carrier.AllowedStates.some(
          (stateValue) =>
            stateValue === selectedStateCode || stateValue === selectedStateName
        )
      )
      .map((carrier) => carrier.CarrierName);

    setValue("step1.allowedCarriers", allowedCarriers, {
      shouldDirty: false,
      shouldValidate: true,
    });
  }, [insuredState, carriersData, setValue]);

  return (
    <div className="space-y-2">
      <DropdownInput
        control={control}
        label="What is the insured's state?"
        dropdownLabel="Select State"
        stepName="step1.insuredState"
        stepId="step1"
        itemList={allowedStates}
        loading={loading}
      />
    </div>
  );
}
